import { render } from "./ShowListInvoice.vue?vue&type=template&id=65aed52a&ts=true"
import script from "./ShowListInvoice.vue?vue&type=script&lang=ts"
export * from "./ShowListInvoice.vue?vue&type=script&lang=ts"

import "./ShowListInvoice.vue?vue&type=style&index=0&id=65aed52a&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_Phoi/ZaloOA_Phoi_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__